import { TextField } from "./SettingsFields";

function GeneralSettingsForm({ settings, onChange }) {
  return (
    <section className="admin-settings-section">
      <TextField label="Business name" name="business_name" value={settings.business_name} onChange={onChange} />
      <TextField label="Tagline" name="tagline" value={settings.tagline} onChange={onChange} />
      <TextField label="Primary phone" name="primary_phone" value={settings.primary_phone} onChange={onChange} />
      <TextField label="Primary email" name="primary_email" value={settings.primary_email} onChange={onChange} type="email" />
      <TextField label="Contact form recipient" name="contact_form_recipient_email" value={settings.contact_form_recipient_email} onChange={onChange} type="email" />
      <TextField label="Copyright text" name="copyright_text" value={settings.copyright_text} onChange={onChange} />
    </section>
  );
}

export default GeneralSettingsForm;